export default __webpack_public_path__ + "static/media/count-down.34824bad.svg";